import { EditorView } from '@codemirror/view';

import type { LanguageMode } from '../types';

export const createEditorStyle = (
  enableJsonPathSearch: boolean,
  hasError: boolean,
  language: LanguageMode,
  lineWrapping: boolean = false
) => {
  const errorHeight = hasError ? 32 : 0;
  const bottomSpace = `${errorHeight}px !important`;
  const isMarkdown = language === 'markdown';

  return EditorView.theme({
    '&': {
      borderRadius: enableJsonPathSearch ? '6px 6px 0 0' : '6px',
      border: '1px solid var(--color-outline)',
      overflow: 'hidden',
      height: '100% !important',
      fontFamily: 'inherit'
    },
    '.cm-scroller': {
      overflowX: lineWrapping ? 'hidden !important' : 'auto',
      overflowY: 'auto',
      height: '100% !important',
      padding: isMarkdown ? '12px' : '0'
    },
    '.cm-editor': {
      height: '100% !important'
    },
    '.cm-content': {
      paddingBottom: bottomSpace,
      paddingTop: isMarkdown ? '8px' : '0',
      fontFamily: isMarkdown
        ? 'system-ui, -apple-system, sans-serif !important'
        : 'inherit'
    },
    '.cm-line': {
      padding: isMarkdown ? '3px 0' : '0',
      lineHeight: isMarkdown ? '1.7' : '1.5'
    },
    '.cm-gutters': {
      display: isMarkdown ? 'none' : 'block'
    },
    '.cm-activeLine': {
      backgroundColor: 'transparent !important'
    },
    '.cm-activeLineGutter': {
      backgroundColor: 'transparent !important'
    },
    '&.cm-focused': {
      outline: 'none',
      boxShadow: 'none'
    }
  });
};
